/**
 *  Cart Auto Add
 *  Keeps the merchant-configured variant in sync with the rest of the cart:
 *  added whenever another item is present, removed once the cart is
 *  otherwise empty. Re-checks after any cart change.
 *  Removal via the UI is blocked at the template level (see
 *  cart-drawer.liquid / main-cart.liquid); this script is the only thing
 *  allowed to add or remove the line item itself.
 */
(function () {
  function getConfig() {
    var settings = (window.theme && window.theme.settings && window.theme.settings.autoAdd) || {};

    return {
      enabled: !!settings.enabled,
      variantId: settings.variantId ? String(settings.variantId) : '',
      propertyLabel: settings.propertyLabel || 'Note',
      propertyText: settings.propertyText || ''
    };
  }

  var isChecking = false;

  function findAutoItem(cart, variantId) {
    return cart.items.find(function (item) {
      return String(item.variant_id) === variantId;
    });
  }

  function otherItemsCount(cart, variantId) {
    return cart.items.reduce(function (count, item) {
      return String(item.variant_id) === variantId ? count : count + item.quantity;
    }, 0);
  }

  function addAutoItem(config) {
    var properties = {};

    if (config.propertyText) {
      properties[config.propertyLabel] = config.propertyText;
    }

    return fetch(theme.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        items: [{
          id: config.variantId,
          quantity: 1,
          properties: properties
        }]
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function removeAutoItem(config) {
    return fetch(theme.routes.cart_change_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: config.variantId,
        quantity: 0
      })
    }).then(function (response) {
      return response.json();
    });
  }

  function maybeSyncAutoItem() {
    var config = getConfig();

    if (!config.enabled || !config.variantId || isChecking) {
      return;
    }

    isChecking = true;

    fetch(theme.routes.cart_url + '.js')
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var autoItem = findAutoItem(cart, config.variantId);
        var othersCount = otherItemsCount(cart, config.variantId);

        if (othersCount === 0) {
          if (autoItem) {
            return removeAutoItem(config);
          }
        } else if (!autoItem) {
          return addAutoItem(config);
        }

        return null;
      })
      .then(function (data) {
        if (!data) {
          return;
        }

        if (data.status) {
          console.error('Cart auto-add sync failed:', data.description || data.message);
          return;
        }

        dispatchCustomEvent('cart:refresh');
      })
      .catch(function (error) {
        console.error('Cart auto-add error:', error);
      })
      .finally(function () {
        isChecking = false;
      });
  }

  document.addEventListener('cart:refresh', maybeSyncAutoItem);
  document.addEventListener('cart:item-added', maybeSyncAutoItem);
  document.addEventListener('cart-drawer:open', maybeSyncAutoItem);
  document.addEventListener('line-item:change:end', maybeSyncAutoItem);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeSyncAutoItem);
  } else {
    maybeSyncAutoItem();
  }
})();
